
const env = process.env.NODE_ENV

const base = {
    PORT:3310,
}

const options = {
    development: {
        SERVER: 'http://47.114.47.71:6310',
        JsonName:'schoolTest',
        OSS:"https://whrlzy-test.oss-cn-hangzhou.aliyuncs.com",
        PageUrl: "http://192.168.0.155:3000"
    },
    production: {
        // SERVER: 'http://47.114.47.71:6310',
        // JsonName:'schoolTest',
        // OSS:"https://whrlzy-test.oss-cn-hangzhou.aliyuncs.com"
        SERVER: 'https://adminapi.teacher.job910.com',
        JsonName:'school',
        OSS:"https://assets.xinyan.job910.com",
        PageUrl: "https://pages.job10000.com"
    }
}
const config = Object.assign(base, options[env])
export default config
